<script>
  let title = "NEW FROM RETURN";
  let content =
    "This return item is New with tag that is waiting to be shipped back by another customer.<br><br> You have limited time to buy this return item.";
</script>

<div class="uturn-container">
  <div class="uturn-title">{title}</div>
  <div class="uturn-content">{@html content}</div>
</div>

<style>
  .uturn-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin: 8px 0;
  }

  .uturn-title {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
  }

  .uturn-content {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }
</style>
